var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.displayValue)?_c('div',{staticClass:"explorer-cell"},[_c('button',{staticClass:"mono explorer-cell__tap",attrs:{"type":"button","title":_vm.displayValue},on:{"click":_vm.onTap}},[_vm._v(" "+_vm._s(_vm.displayValue)+" ")])]):_c('span',{staticClass:"cell-muted"},[_vm._v("—")])
}
var staticRenderFns = []

export { render, staticRenderFns }